import i18n from '@/i18n';
import VuetifyInstance from '@/plugins/vuetify';

const state = {
  shortDateFormat: 'DD.MM.YYYY',
  shortMonthFormat: 'MM.YYYY',
  locale: 'ru-RU',
  localeShort: 'ru',
  darkTheme: false,
  drawerOpen: true,
};

const mutations = {
  setDrawer (state, data) {
    state.drawerOpen = data;
  },
  setLocale (state, data) {
    state.locale = data;
    i18n.locale  = state.locale;
  },
  setLocaleShort (state, data) {
    state.localeShort = data;
  },
  switchDarkTheme (state) {
    state.darkTheme                      = !state.darkTheme;
    VuetifyInstance.framework.theme.dark = state.darkTheme;
  },
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
